export default __webpack_public_path__ + "static/blob12-a7f8029914fd7fea2ef4cc0c5ee9d56d.svg";